<div class="live-feed-header" *ngIf="company">
  <div class="live-feed-header__company">
    <img [src]="logoUrl" />
    <div>
      <h2>Dobrodošli u {{ company.loyaltyName }}!</h2>
      <p class="live-feed-header__subtitle">
        Pratite uživo poredak naših najvjernijih kupaca koji koriste
        <app-lomy-logo size="p"></app-lomy-logo>
        aplikaciju ovdje. <br />Hvala što ste s nama!
      </p>
    </div>
    <div class="fullscreen-button" *ngIf="!isFullscreen">
      <mat-icon (click)="requestFullscreen()">fullscreen</mat-icon>
    </div>
  </div>
</div>

<main>
  <div class="content-wrapper">
    <mat-card class="users-list-table mat-elevation-z5">
      <p>
        Zadnje osvježavanje:
        <span class="text--pink">{{
          lastRefreshTime | date : "dd.MM.yyyy. HH:mm"
        }}</span>
      </p>
      <div class="table-container" #tableContainer>
        <table mat-table [dataSource]="rankingList">
          <ng-container matColumnDef="trophy">
            <th mat-header-cell *matHeaderCellDef></th>
            <td [width]="1" mat-cell *matCellDef="let element; let i = index">
              <ng-container *ngIf="i === 0">
                <mat-icon class="trophy-icon gold">emoji_events</mat-icon>
              </ng-container>
              <ng-container *ngIf="i === 1">
                <mat-icon class="trophy-icon silver">emoji_events</mat-icon>
              </ng-container>
              <ng-container *ngIf="i === 2">
                <mat-icon class="trophy-icon bronze">emoji_events</mat-icon>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="ranking">
            <th mat-header-cell *matHeaderCellDef>Mjesto</th>
            <td [width]="1" mat-cell *matCellDef="let element; let i = index">
              {{ i + 1 }}.
            </td>
          </ng-container>

          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef>Korisničko ime</th>
            <td mat-cell *matCellDef="let element">{{ element.username }}</td>
          </ng-container>

          <ng-container matColumnDef="totalPoints">
            <th mat-header-cell *matHeaderCellDef>
              Ukupan broj potrošenih bodova
            </th>
            <td mat-cell [width]="'200px'" *matCellDef="let element">
              {{ getPointsWithSuffix(element.totalPoints, false) }}
              <div
                *ngIf="element.showLastTransaction"
                style="margin-top: -30px"
              >
                <br />
                <span
                  style="font-size: 0.9rem; font-weight: bold"
                  class="text--pink"
                  >{{
                    getPointsWithSuffix(element.lastTransactionPoints, true)
                  }}</span
                >
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="lastTransactionTime">
            <th mat-header-cell *matHeaderCellDef>Zadnja aktivnost</th>
            <td mat-cell *matCellDef="let element">
              {{ element.lastTransactionPoints }} bodova u <br />
              {{ element.lastTransactionTime | date : "short" }}
            </td>
          </ng-container>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{
              'text--medium':
                rankingList.length > 10 && rankingList.indexOf(row) < 5
            }"
          ></tr>
        </table>
      </div>
    </mat-card>
    <mat-card class="lomy-info-card mat-elevation-z5">
      <div class="lomy-info">
        <div class="lomy-info__logo-content">
          <img
            src="../../../../../assets/images/logo-login.png"
            class="lomy-info__logo"
          />
          <div class="lomy-info__title">
            <app-lomy-logo size="h1"></app-lomy-logo>
            <div>{{ "login.oneLoyalFamily" | transloco }}</div>
          </div>
        </div>
        <div class="lomy-info__content">
          <h4>Sudjelujte i <span class="text--pink">VI</span>!</h4>
          <p>
            Preuzmite
            <app-lomy-logo size="p"></app-lomy-logo>
            aplikaciju i skupljajte bodove!
          </p>
          <div class="download-icons">
            <img src="../../../../../assets/images/App-store-download.webp" />
            <img src="../../../../../assets/images/play-store-download.webp" />
          </div>
          <div>
            <h4>
              Posjetite našu
              <span class="text--pink text--medium">web stranicu!</span>
            </h4>
            <img src="../../../../../assets/images/LOMY-web-QR-code.png" />
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</main>
